<template>
  <div class="jackpot-physical-help-wrapper">
    <div class="mb-md">
      <strong class="text-white text-uppercase">Instant Payout:</strong> Received upon collecting a Jackpot ticket
    </div>

    <ul style="list-style-type: none">
      <li class="flex-center">
        <span class="flex-center w-100">
          <img class="img-small" src="@/assets/images/mini-ticket.webp" />
          <span style="color: #29ffff; text-transform: uppercase">Mini </span>
        </span>
        <span>Up to <strong>$50 USD</strong> can be earned</span>
      </li>
      <li class="flex-center">
        <span class="flex-center w-100">
          <img class="img-small" src="@/assets/images/minor-ticket.webp" />
          <span style="color: #5ce386; text-transform: uppercase">Minor </span>
        </span>
        <span>Up to <strong>$250 USD</strong> can be earned</span>
      </li>
      <li class="flex-center">
        <span class="flex-center w-100">
          <img class="img-small" src="@/assets/images/major-ticket.webp" />
          <span style="color: #ff6f8b; text-transform: uppercase">Major </span>
        </span>
        <span>Up to <strong>$500 USD</strong> can be earned</span>
      </li>
    </ul>
    <div class="mb-md"><strong class="text-white text-uppercase">Lucky draw:</strong> Prize awarded in every draw</div>

    <div class="prize-header major">
      <div>Major Prize:</div>
      <div>1 Winner</div>
    </div>
    <div class="prize-content">
      <div class="prize-content-left">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/major-gold.webp" />
        <div>Doji 999.9 gold (18.75g)</div>
      </div>
      <div class="prize-content-mid">OR</div>
      <div class="prize-content-right">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/major-prize.webp" />
        <div>Iphone 15 Pro max (256gb)</div>
      </div>
    </div>

    <div class="prize-header minor">
      <div>Minor Prize:</div>
      <div>3 Winners</div>
    </div>
    <div class="prize-content">
      <div class="prize-content-left">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/minor-gold.webp" />
        <div>Doji 999.9 gold (3.75g)</div>
      </div>
      <div class="prize-content-mid">OR</div>
      <div class="prize-content-right">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/minor-prize.webp" />
        <div>PS5 Slim</div>
      </div>
    </div>

    <div class="prize-header mini">
      <div>Mini Prize:</div>
      <div>8 Winners</div>
    </div>
    <div class="prize-content">
      <div class="prize-content-left">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/mini-gold.webp" />
        <div>Doji 999.9 gold (1.875g)</div>
      </div>
      <div class="prize-content-mid">OR</div>
      <div class="prize-content-right">
        <img class="img-small" src="@/assets/images/game-help/jackpot/physical/mini-prize.webp" />
        <div>Nintendo Switch (Lite)</div>
      </div>
    </div>

    <div class="h1">Term and Conditions</div>
    <ul style="list-style-type: none">
      <li>
        1. Winners will receive notification via email inbox. Please follow the instructions provided in the email to
        claim your prize.
      </li>
      <li>2. Prize not claimed without 45 days will be forfeited.</li>
      <li>3. Winner information will be kept confidential.</li>
    </ul>
    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
import BurgerMenu from '@/components/burger-menu.vue';
import { isMobile } from 'mobile-device-detect';
export default {
  components: {
    BurgerMenu,
  },
  data: () => {
    return {
      isMobile,
    };
  },
};
</script>
<style lang="scss" scoped>
.jackpot-physical-help-wrapper {
  padding: 16px 24px;
  box-sizing: border-box;
  height: calc(100% - 56px);
  overflow-y: auto;
  font-size: 12px;
  color: #b2d6ea;
}

strong {
  font-weight: 600;
}

.h1 {
  font-size: 14px;
  color: #fff;
  text-transform: uppercase;
  margin: 12px 0;
}

.h2 {
  font-size: 12px;
  color: #b2d6ea;
  text-transform: uppercase;
}

.text-white {
  color: #fff;
}

.flex-center {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.img-small {
  height: 18px;
  margin-right: 8px;
}

.mb-md {
  margin-bottom: 24px;
}

.mr-lg {
  margin-right: 32px;
}

ul {
  padding-inline-start: 0;
}

li {
  min-height: 20px;
  margin: 0.8rem 0;
}

.w-100 {
  width: 100px;
}

.text-uppercase {
  text-transform: uppercase;
}

.prize-header {
  padding: 8px 12px;
  border-radius: 4px;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;

  &.major {
    border: solid 1px rgba(0, 0, 0, 0);
    background-color: #46141e;
    color: #ff6f8b;
  }

  &.minor {
    border: solid 1px rgba(0, 0, 0, 0);
    background-color: #1a4126;
    color: #5ce386;
  }

  &.mini {
    border: solid 1px rgba(0, 0, 0, 0);
    background-color: #0d3c43;
    color: #29ffff;
  }
}

.prize-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0;
  img {
    width: 100%;
    height: auto;
    padding: 0 8px;
    box-sizing: border-box;
  }
  &-left,
  &-right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex: 1 0 30%;
  }
}
</style>
